// Do not modify this file by hand!
// Re-generate this file by running lit-localize.

/**
 * The locale code that templates in this source code are written in.
 */
export const sourceLocale = `en`;

/**
 * The other locale codes that this application is localized into. Sorted
 * lexicographically.
 */
export const targetLocales = [
  `cs`,
  `da`,
  `de`,
  `el`,
  `es`,
  `fa`,
  `fr`,
  `hu`,
  `it`,
  `ja`,
  `km`,
  `ko`,
  `nl`,
  `no`,
  `pl`,
  `pt`,
  `ru`,
  `sr`,
  `sv`,
  `tr`,
  `uk`,
  `vi`,
  `zh-CN`,
  `zh-HK`,
] as const;

/**
 * All valid project locale codes. Sorted lexicographically.
 */
export const allLocales = [
  `cs`,
  `da`,
  `de`,
  `el`,
  `en`,
  `es`,
  `fa`,
  `fr`,
  `hu`,
  `it`,
  `ja`,
  `km`,
  `ko`,
  `nl`,
  `no`,
  `pl`,
  `pt`,
  `ru`,
  `sr`,
  `sv`,
  `tr`,
  `uk`,
  `vi`,
  `zh-CN`,
  `zh-HK`,
] as const;
